import { User } from 'entities/User/types';

export const CoUserStatus = {
	active: 'ACTIVE',
	invited: 'INVITED',
} as const;

export type CoUser = {
	_id: string;
	invitedBy: Pick<User, '_id' | 'firstName' | 'lastName'>;
	email?: string;
	status?: (typeof CoUserStatus)[keyof typeof CoUserStatus];
	userId?: Pick<User, '_id' | 'email' | 'firstName' | 'lastName'>;
	joinedAt: string;
	createdAt: string;
	filesCounter: 0;
};
